module.exports = __webpack_public_path__ + "img/desktop_icon.df7a55ff.svg";